module.exports = __webpack_public_path__ + "static/media/default-avatarF.60df819f.png";